
import { useState } from "react";

import ProductSelector from "@/components/designer/panels/ProductSelector";
import UploadPanel from "@/components/designer/panels/UploadPanel";
import TextPanel from "@/components/designer/panels/TextPanel";
import LayersPanel from "@/components/designer/panels/LayersPanel";
import SizePanel from "@/components/designer/panels/SizePanel";
import ImageQualityPanel from "@/components/designer/panels/ImageQualityPanel";
import ColorPanel from "@/components/designer/panels/ColorPanel";

export default function StudioSidebar() {
  const [tab, setTab] = useState("products");

  const buttonStyle = (active: boolean) =>
    `w-full rounded-xl py-4 font-semibold transition ${
      active
        ? "bg-cyan-600 text-white"
        : "bg-slate-700 hover:bg-slate-600 text-white"
    }`;

  return (
    <aside className="rounded-2xl bg-[#141d2e] border border-slate-700 shadow-xl p-5">

      <h2 className="text-3xl font-black text-white mb-6">
        Designer
      </h2>

      <div className="space-y-3">

        <button
          onClick={() => setTab("products")}
          className={buttonStyle(tab === "products")}
        >
          👕 Products
        </button>

        <button
          onClick={() => setTab("upload")}
          className={buttonStyle(tab === "upload")}
        >
          🖼 Upload
        </button>

        <button
          onClick={() => setTab("text")}
          className={buttonStyle(tab === "text")}
        >
          ✍ Text
        </button>

        <button
          onClick={() => setTab("layers")}
          className={buttonStyle(tab === "layers")}
        >
          🗂 Layers
        </button>

      </div>

      <div className="mt-6">

        {tab === "products" && <ProductSelector />}

        {tab === "upload" && <UploadPanel />}

        {tab === "text" && <TextPanel />}

        {tab === "layers" && <LayersPanel />}

      </div>

      <div className="mt-8 space-y-4">

        <ColorPanel />

        <SizePanel />

        <ImageQualityPanel />

      </div>

    </aside>
  );
}